import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import {
    getChallenge,
    getTopContributors,
    getContributorsLoading,
    getChallengeCodesForTopContributors,
} from '../selectors';
import { topContributorsRequested, setSelectedCode } from '../actions';
import { DROPDOWNDATA } from './constants';
import TopContributorsCard from '../../../common/TopContributorsCard';

function TopContributors({
    onLoad,
    onChangeMode,
    topContributors,
    contributorsLoading,
    challenge,
    challengeCodes,
}) {
    useEffect(() => {
        if (challenge.id && !contributorsLoading) onLoad(DROPDOWNDATA[0].key);
    }, [challenge]);

    return (
        <TopContributorsCard
            showSecondDd={true}
            topContributors={topContributors}
            loading={contributorsLoading}
            onSelect={onLoad}
            onChangeMode={onChangeMode}
            challengeCodes={challengeCodes}
            challengeCodesLoading={contributorsLoading}
            className="d-flex flex-column"
        />
    );
}

TopContributors.propTypes = {
    challenge: PropTypes.object,
    // function to be called when component is initialized
    onLoad: PropTypes.func.isRequired,
    onChangeMode: PropTypes.func,
    // contributors to be listed in component
    topContributors: PropTypes.arrayOf(PropTypes.object).isRequired,
    // boolean value to determine whether to show the loader
    contributorsLoading: PropTypes.bool,
    challengeCodes: PropTypes.array,
    challengeCodesLoading: PropTypes.bool,
};

const mapStateToProps = (state) => {
    return {
        challenge: getChallenge(state),
        topContributors: getTopContributors(state),
        contributorsLoading: getContributorsLoading(state),
        challengeCodes: getChallengeCodesForTopContributors(state),
        challengeCodesLoading: getContributorsLoading(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onLoad: (date, customDate) =>
            dispatch(topContributorsRequested(date, customDate)),
        onChangeMode: (value) => dispatch(setSelectedCode(value)),
    };
};

const ConnectedTopContributors = connect(
    mapStateToProps,
    mapDispatchToProps,
)(TopContributors);

export default ConnectedTopContributors;
